import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchQuery: '',
  searchDropValue: undefined,
  selectedTabValue: '1',
  navigatedAway: false,
  preserveSearch: false, // Flag to determine if search should be preserved
};

const invoiceSearchSlice = createSlice({
  name: 'invoiceSearch',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setSearchDropValue: (state, action) => {
      state.searchDropValue = action.payload;
    },
    setSelectedTabValue: (state, action) => {
      state.selectedTabValue = action.payload;
    },
    setNavigatedAway: (state, action) => {
      state.navigatedAway = action.payload;
    },
    setPreserveSearch: (state, action) => {
      state.preserveSearch = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = '';
      state.searchDropValue = undefined;
    },
    resetInvoiceSearch: (state, action) => {
      // Only reset if we shouldn't preserve search
      if (action?.payload?.force || !state.preserveSearch) {
        return initialState;
      }
      // If preserveSearch is true, only reset navigation flags
      state.navigatedAway = false;
      state.preserveSearch = false;
    },
  },
});

export const {
  setSearchQuery,
  setSearchDropValue,
  setSelectedTabValue,
  setNavigatedAway,
  setPreserveSearch,
  clearSearch,
  resetInvoiceSearch,
} = invoiceSearchSlice.actions;

export default invoiceSearchSlice.reducer;